import { render, staticRenderFns } from "./TextAttr.vue?vue&type=template&id=5ca74438&scoped=true&"
import script from "./TextAttr.vue?vue&type=script&lang=js&"
export * from "./TextAttr.vue?vue&type=script&lang=js&"
import style0 from "./TextAttr.vue?vue&type=style&index=0&id=5ca74438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca74438",
  null
  
)

export default component.exports